import React, { Fragment } from 'react';
//import DynamicComponent from '../../Components/DynamicComponent';*
//import PnIconResolver from './PnIconResolver';

import SearchIcon from '../../_Solution/Icons/pn_search.svg?component';
import CartIcon from '../../_Solution/Icons/shopping_cart.svg?component';
import AccountIcon from '../../_Solution/Icons/account.svg?component';
import LogoutIcon from '../../_Solution/Icons/logout.svg?component';
import WebsitesIcon from '../../_Solution/Icons/websites.svg?component';
import AddIcon from '../../_Solution/Icons/add.svg?component';
import RemoveIcon from '../../_Solution/Icons/remove.svg?component';
import CloseIcon from '../../_Solution/Icons/close.svg?component';
import ExpandIcon from '../../_Solution/Icons/expand.svg?component';
import ShowHeaderIcon from '../../_Solution/Icons/show-header.svg?component';
import WarningIcon from '../../_Solution/Icons/warning.svg?component';
import NoImage from '../../_Solution/Icons/no-image.svg?component';
import NoImageClean from '../../_Solution/Icons/no-image-clean.svg?component';
import Download from '../../_Solution/Icons/download.svg?component';
import Outward from '../../_Solution/Icons/outward.svg?component';
import UploadFile from '../../_Solution/Icons/upload_file.svg?component';
import Edit from '../../_Solution/Icons/edit.svg?component';
import Settings from '../../_Solution/Icons/settings.svg?component';

// File Extensions
import FileFormat_avi from '../../_Solution/Icons/FileExtensions/avi.svg?component';
import FileFormat_css from '../../_Solution/Icons/FileExtensions/css.svg?component';
import FileFormat_csv from '../../_Solution/Icons/FileExtensions/csv.svg?component';
import FileFormat_dll from '../../_Solution/Icons/FileExtensions/csv.svg?component';
import FileFormat_doc from '../../_Solution/Icons/FileExtensions/csv.svg?component';
import FileFormat_eps from '../../_Solution/Icons/FileExtensions/eps.svg?component';
import FileFormat_exe from '../../_Solution/Icons/FileExtensions/exe.svg?component';
import FileFormat_gif from '../../_Solution/Icons/FileExtensions/gif.svg?component';
import FileFormat_htm from '../../_Solution/Icons/FileExtensions/html.svg?component';
import FileFormat_jpg from '../../_Solution/Icons/FileExtensions/jpg.svg?component';
import FileFormat_js from '../../_Solution/Icons/FileExtensions/js.svg?component';
import FileFormat_mov from '../../_Solution/Icons/FileExtensions/mov.svg?component';
import FileFormat_mp3 from '../../_Solution/Icons/FileExtensions/mp3.svg?component';
import FileFormat_mp4 from '../../_Solution/Icons/FileExtensions/mp4.svg?component';
import FileFormat_pdf from '../../_Solution/Icons/FileExtensions/pdf.svg?component';
import FileFormat_php from '../../_Solution/Icons/FileExtensions/php.svg?component';
import FileFormat_png from '../../_Solution/Icons/FileExtensions/png.svg?component';
import FileFormat_ppt from '../../_Solution/Icons/FileExtensions/ppt.svg?component';
import FileFormat_psd from '../../_Solution/Icons/FileExtensions/psd.svg?component';
import FileFormat_rar from '../../_Solution/Icons/FileExtensions/rar.svg?component';
import FileFormat_txt from '../../_Solution/Icons/FileExtensions/txt.svg?component';
import FileFormat_wav from '../../_Solution/Icons/FileExtensions/wav.svg?component';
import FileFormat_xls from '../../_Solution/Icons/FileExtensions/xls.svg?component';
import FileFormat_zip from '../../_Solution/Icons/FileExtensions/zip.svg?component';
const PnIcon = ({
  iconName,
  title,
  cssClass = '',
  width = 24,
  height = 24,
}) => {
  //const Icon = Icons[iconName];
  //if (Icon) {
  //  <Icon
  //    width={width}
  //    height={height}
  //    className={`pn-icon__${iconName} ${cssClass}`}
  //    title={title}
  //  />;
  //}
  //const Icon = DynamicComponent({
  //    loader: () => import(`../../_Solution/Icons/${iconName}.svg?component`),
  //});
  //if (Icon) {
  //    return (<Icon width={width} height={height} className={`pn-icon__${iconName} ${cssClass}`} title={title} />);
  //}
  if (iconName === 'search') {
    return (
      <SearchIcon
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'cart') {
    return (
      <CartIcon
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'account') {
    return (
      <AccountIcon
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'no-image') {
    return (
      <NoImage
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'no-image-clean') {
    return (
      <NoImageClean
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'warning') {
    return (
      <WarningIcon
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'logout') {
    return (
      <LogoutIcon
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'websites') {
    return (
      <WebsitesIcon
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'add') {
    return (
      <AddIcon
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'remove') {
    return (
      <RemoveIcon
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'close') {
    return (
      <CloseIcon
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'expand') {
    return (
      <ExpandIcon
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'show-header') {
    return (
      <ShowHeaderIcon
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'download') {
    return (
      <Download
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'outward') {
    return (
      <Outward
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  }
  else if (iconName === 'upload-file') {
    return (
        <UploadFile
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'edit') {
      return (
          <Edit
              width={width}
              height={height}
              className={`pn-icon__${iconName} ${cssClass}`}
              title={title}
          />
      );
  } else if (iconName === 'settings') {
      return (
          <Settings
              width={width}
              height={height}
              className={`pn-icon__${iconName} ${cssClass}`}
              title={title}
          />
      );
  }
  // File Formats
  else if (iconName === 'avi') {
    return (
      <FileFormat_avi
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'css' || iconName === 'scss') {
    return (
      <FileFormat_css
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'csv') {
    return (
      <FileFormat_csv
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'dll') {
    return (
      <FileFormat_dll
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'doc' || iconName === 'docx') {
    return (
      <FileFormat_doc
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'eps') {
    return (
      <FileFormat_eps
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'exe') {
    return (
      <FileFormat_exe
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'gif') {
    return (
      <FileFormat_gif
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'htm' || iconName === 'html') {
    return (
      <FileFormat_htm
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'jpg' || iconName === 'jpeg') {
    return (
      <FileFormat_jpg
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'js') {
    return (
      <FileFormat_js
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'mov') {
    return (
      <FileFormat_mov
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'mp3') {
    return (
      <FileFormat_mp3
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'mp4') {
    return (
      <FileFormat_mp4
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'pdf') {
    return (
      <FileFormat_pdf
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'php') {
    return (
      <FileFormat_php
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'png') {
    return (
      <FileFormat_png
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'ppt' || iconName === 'pptx') {
    return (
      <FileFormat_ppt
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'psd') {
    return (
      <FileFormat_psd
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'rar') {
    return (
      <FileFormat_rar
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'txt') {
    return (
      <FileFormat_txt
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'wav') {
    return (
      <FileFormat_wav
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'xls' || iconName === 'xlsx') {
    return (
      <FileFormat_xls
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  } else if (iconName === 'zip') {
    return (
      <FileFormat_zip
        width={width}
        height={height}
        className={`pn-icon__${iconName} ${cssClass}`}
        title={title}
      />
    );
  }
  return null;
};

export default PnIcon;
